<template>
  <div class="pagination-wrapper">
    <el-pagination
      class="is-print-hide common-el-pagination"
      @current-change="handlePage"
      :current-page="currentPage"
      layout="prev, pager, next, total, jumper"
      :total="total"
      :page-size="pageSize"
    ></el-pagination>
    <div class="sureJump global_common_button_goast">确定</div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    total: {
      type: Number,
      default: 12
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handlePage(page) {
      this.$emit('handlePage', page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
